import * as Sentry from "@sentry/react";
import logger from "./logger";

/**
 * Tracks a tab change in Sentry for both error and performance transactions.
 * @param pathname The current route pathname (e.g., location.pathname)
 * @param tabKey The tab key (number or string)
 * @param tabLabel The tab label (string)
 */
export function trackTabChangeWithSentry(pathname: string, tabKey: number | string, tabLabel?: string) {
  try {
    // Normalize pathname: remove trailing slashes (except for root)
    let normalizedPath = pathname.replace(/\/+$/, "");
    if (normalizedPath === "") normalizedPath = "/";

    // Set Sentry transaction name for error events
    if (Sentry.getCurrentScope) {
      Sentry.getCurrentScope().setTransactionName(`${normalizedPath}?tab=${tabKey}`);
    }

    // Update the root span name for the active Sentry transaction (for Performance dashboard)
    if (Sentry.getActiveSpan && Sentry.getRootSpan && Sentry.updateSpanName) {
      const activeSpan = Sentry.getActiveSpan();
      const rootSpan = activeSpan && Sentry.getRootSpan(activeSpan);
      if (rootSpan) {
        Sentry.updateSpanName(rootSpan, `${normalizedPath}?tab=${tabKey}`);
      }
    }

    // Add a Sentry breadcrumb for tab change
    Sentry.addBreadcrumb({
      category: "ui.tab.change",
      message: `User switched to tab: ${tabLabel || `Tab ${tabKey}`}`,
      level: "info",
    });
  }
  catch (error) {
    logger.error(`${trackTabChangeWithSentry.name}`, error);
  }
}
